import { Grid } from '@mui/material';
import { ReportType } from 'generated/graphql';
import { useGetList } from 'react-admin';

import { ClientStatsCard } from './ClientStatsCard';
import { ReportStatsCard } from './ReportStatsCard';
import { UserInvitationStatsCard } from './UserInvitationStatsCard';

export const ScoutDashboard: React.FC = () => {
  const { data: clients, isLoading: isLoadingClients } = useGetList('Client', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });

  const { data: userInvitations, isLoading: isLoadingUserInvitations } = useGetList('UserInvitation', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });
  const { data: reports, isLoading: isLoadingReports } = useGetList('Report', {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: 'creationTimestamp', order: 'DESC' },
  });
  return (
    <Grid container mt={2} spacing={2}>
      <Grid item md={4} sm={12}>
        <UserInvitationStatsCard isLoading={isLoadingUserInvitations} userInvitations={userInvitations} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ClientStatsCard clients={clients} isLoading={isLoadingClients} />
      </Grid>
      <Grid item md={4} sm={12}>
        <ReportStatsCard isLoading={isLoadingReports} reportType={ReportType.Finoptio} reports={reports} />
      </Grid>
    </Grid>
  );
};
